import { useNavigate } from "react-router-dom";
import { appRouterPaths } from "@/services/navigation";
import { useAppDispatch } from "@/services/store";
import { DEFAULT_NOTE_TYPES, type Note } from "@/services/api";
import { commitmentsPageActions } from "@/pages/CommitmentsPage";
import { ideasPageActions } from "@/pages/IdeasPage";
import { notesContentActions } from "@/pages/NotesPage/model";

export const useNotesRedirect = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const redirect = ({ note }: { note: Note }) => {
    switch (note.noteType.name) {
      case DEFAULT_NOTE_TYPES.DEFAULT_COMMITMENT:
        navigate(appRouterPaths.commitments);
        dispatch(commitmentsPageActions.openNoteById({ noteId: note.id }));
        break;
      case DEFAULT_NOTE_TYPES.DEFAULT_IDEA:
        navigate(appRouterPaths.ideas);
        dispatch(ideasPageActions.openNoteById({ noteId: note.id }));
        break;
      default:
        navigate(appRouterPaths.notes);
        dispatch(notesContentActions.openNoteById({ noteId: note.id }));
        break;
    }
  };

  return { redirect };
};
